import React, {useMemo} from "react";
import './Suspense.scss';
import IconSuspense from "../client/common/IconSuspense";

export type SuspenseComponentProps = {
    size?: 'xs' | 'md' | 'lg'
}

function SuspenseComponent({size = 'lg'}: SuspenseComponentProps) {
    const sizes = useMemo(() => ({
        xs: '1em',
        md: '3em',
        lg: '5em'
    }), [])

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <IconSuspense size={sizes[size]}/>
        </div>
    )
}

export default SuspenseComponent;